// ⚠️ AUTO-GENERATED by scripts/generateBeats.js — DO NOT EDIT
// Ses dosyaları repo'da değil, Cloudflare R2'de. Bu dosya sadece katalog.
// Güncellemek için: npm run beats:generate && npm run beats:upload
export const beatsItems = [
  {
    "id": "90s/98-bpm-e-maj-ryngy",
    "title": "98 Bpm E Maj (RYNGY)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/98-bpm-e-maj-ryngy.mp3",
    "source": "90's/98 Bpm E Maj (RYNGY).mp3"
  },
  {
    "id": "melodic-trap/122-bpm-d-sharp-min-kentucky-drippin",
    "title": "122 Bpm D# Min (Kentucky Drippin)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/122-bpm-d-sharp-min-kentucky-drippin.mp3",
    "source": "Melodic Trap/122 Bpm D# Min (Kentucky Drippin).mp3"
  },
  {
    "id": "dance-music/129-bpm-d-sharp-min-isiklar",
    "title": "129 Bpm D# Min (Isıklar)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/129-bpm-d-sharp-min-isiklar.mp3",
    "source": "Dance Music/129 Bpm D# Min (Isıklar).mp3"
  },
  {
    "id": "southside-trap/140-bpm-d-sharp-min-eskikid",
    "title": "140 Bpm D# Min (Eskikid)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/140-bpm-d-sharp-min-eskikid.mp3",
    "source": "Southside Trap/140 Bpm D# Min (Eskikid).mp3"
  },
  {
    "id": "zateviss/147-bpm-f-sharp-maj-yesiloda",
    "title": "147 Bpm F# Maj (YesilOda)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/147-bpm-f-sharp-maj-yesiloda.mp3",
    "source": "Zateviss/147 Bpm F# Maj (YesilOda).mp3"
  },
  {
    "id": "southside-trap/118-bpm-c-min-cotbells",
    "title": "118 Bpm C Min (CotBells)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/118-bpm-c-min-cotbells.mp3",
    "source": "Southside Trap/118 Bpm C Min (CotBells).mp3"
  },
  {
    "id": "diger/135-bpm-a-maj-new-carlo-type",
    "title": "135 Bpm A Maj (New Carlo Type)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/135-bpm-a-maj-new-carlo-type.mp3",
    "source": "Diğer/135 Bpm A Maj (New Carlo Type).mp3"
  },
  {
    "id": "90s/103-bpm-d-sharp-min-mi-gente",
    "title": "103 Bpm D# Min (MI GENTE!!!!)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/103-bpm-d-sharp-min-mi-gente.mp3",
    "source": "90's/103 Bpm D# Min (MI GENTE!!!!).mp3"
  },
  {
    "id": "90s/91-bpm-d-min-method-man",
    "title": "91 Bpm D Min (Method Man)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/91-bpm-d-min-method-man.mp3",
    "source": "90's/91 Bpm D Min (Method Man).mp3"
  },
  {
    "id": "diger/140-bpm-g-sharp-min-reels-x-tavian-d-petitt",
    "title": "140 Bpm G# Min (Reels x Tavian d. Petitt )",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/140-bpm-g-sharp-min-reels-x-tavian-d-petitt.mp3",
    "source": "Diğer/140 Bpm G# Min (Reels x Tavian d. Petitt ).mp3"
  },
  {
    "id": "melodic-trap/92-bpm-e-min-duygusal-trampet-piyano",
    "title": "92 Bpm E Min (Duygusal Trampet Piyano)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/92-bpm-e-min-duygusal-trampet-piyano.mp3",
    "source": "Melodic Trap/92 Bpm E Min (Duygusal Trampet Piyano).mp3"
  },
  {
    "id": "melodic-trap/95-bpm-f-min-bgang",
    "title": "95 Bpm F Min (BGang)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/95-bpm-f-min-bgang.mp3",
    "source": "Melodic Trap/95 Bpm F Min (BGang).mp3"
  },
  {
    "id": "southside-trap/138-bpm-e-min-ethnic-southside-type",
    "title": "138 Bpm E Min (Ethnic Southside Type)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/138-bpm-e-min-ethnic-southside-type.mp3",
    "source": "Southside Trap/138 Bpm E Min (Ethnic Southside Type).mp3"
  },
  {
    "id": "zateviss/150-bpm-d-min-don-t-blink",
    "title": "150 Bpm D Min (Don t Blink)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/150-bpm-d-min-don-t-blink.mp3",
    "source": "Zateviss/150 Bpm D Min (Don_t Blink).mp3"
  },
  {
    "id": "zateviss/128-bpm-f-sharp-min-skelly-type",
    "title": "128 Bpm F# Min (Skelly Type)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/128-bpm-f-sharp-min-skelly-type.mp3",
    "source": "Zateviss/128 Bpm F# Min (Skelly Type).mp3"
  },
  {
    "id": "melodic-trap/117-bpm-g-min-psttt",
    "title": "117 Bpm G Min (Psttt)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/117-bpm-g-min-psttt.mp3",
    "source": "Melodic Trap/117 Bpm G Min (Psttt).mp3"
  },
  {
    "id": "diger/130-bpm-d-min-srnyr",
    "title": "130 Bpm D Min (Srnyr)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/130-bpm-d-min-srnyr.mp3",
    "source": "Diğer/130 Bpm D Min (Srnyr).mp3"
  },
  {
    "id": "diger/141-bpm-g-min-marijuana",
    "title": "141 Bpm G Min (Marijuana)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/141-bpm-g-min-marijuana.mp3",
    "source": "Diğer/141 Bpm G Min (Marijuana).mp3"
  },
  {
    "id": "melodic-trap/140-bpm-d-min-decap",
    "title": "140 Bpm D Min (Decap)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/140-bpm-d-min-decap.mp3",
    "source": "Melodic Trap/140 Bpm D Min (Decap).mp3"
  },
  {
    "id": "zateviss/140-bpm-d-sharp-maj-forgive",
    "title": "140 Bpm D# Maj (Forgive)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/140-bpm-d-sharp-maj-forgive.mp3",
    "source": "Zateviss/140 Bpm D# Maj (Forgive).mp3"
  },
  {
    "id": "diger/150-bpm-e-maj-off-the-grid-x-jersey",
    "title": "150 Bpm E Maj (Off The Grid x Jersey)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/150-bpm-e-maj-off-the-grid-x-jersey.mp3",
    "source": "Diğer/150 Bpm E Maj (Off The Grid x Jersey).mp3"
  },
  {
    "id": "dance-music/130-bpm-d-min-para-yapmakta",
    "title": "130 Bpm D Min (Para Yapmakta)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/130-bpm-d-min-para-yapmakta.mp3",
    "source": "Dance Music/130 Bpm D Min (Para Yapmakta).mp3"
  },
  {
    "id": "ambient/100-200-bpm-d-sharp-min-1-1-10",
    "title": "100 200 Bpm D# Min (1+1=10)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/100-200-bpm-d-sharp-min-1-1-10.mp3",
    "source": "Ambient/100-200 Bpm D# Min (1+1=10).mp3"
  },
  {
    "id": "southside-trap/160-bpm-d-sharp-min-gorlock-the-destroyer",
    "title": "160 Bpm D# Min (Gorlock The Destroyer)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/160-bpm-d-sharp-min-gorlock-the-destroyer.mp3",
    "source": "Southside Trap/160 Bpm D# Min (Gorlock The Destroyer).mp3"
  },
  {
    "id": "ambient/135-bpm-c-min-seasover-root-d-sharp",
    "title": "135 Bpm C Min (Seasover (Root D#) )",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/135-bpm-c-min-seasover-root-d-sharp.mp3",
    "source": "Ambient/135 Bpm C Min (Seasover (Root D#) ).mp3"
  },
  {
    "id": "hoodtrap/140-bpm-d-sharp-min-jazz-but-hoodtrap",
    "title": "140 Bpm D# Min (Jazz but HoodTrap)",
    "type": "Hoodtrap",
    "genre": "Hoodtrap",
    "key": "beats/hoodtrap/140-bpm-d-sharp-min-jazz-but-hoodtrap.mp3",
    "source": "Hoodtrap/140 Bpm D# Min (Jazz but HoodTrap).mp3"
  },
  {
    "id": "zateviss/125-bpm-d-maj-turqu",
    "title": "125 Bpm D Maj (Turqu)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/125-bpm-d-maj-turqu.mp3",
    "source": "Zateviss/125 Bpm D Maj (Turqu).mp3"
  },
  {
    "id": "southside-trap/133-bpm-c-sharp-min-crank-fr",
    "title": "133 Bpm C# Min (Crank fr)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/133-bpm-c-sharp-min-crank-fr.mp3",
    "source": "Southside Trap/133 Bpm C# Min (Crank fr).mp3"
  },
  {
    "id": "diger/130-bpm-c-sharp-min-2050",
    "title": "130 Bpm C# Min (2050)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/130-bpm-c-sharp-min-2050.mp3",
    "source": "Diğer/130 Bpm C# Min (2050).mp3"
  },
  {
    "id": "southside-trap/146-bpm-d-sharp-min-smokmimi",
    "title": "146 Bpm D# Min (Smokmimi)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/146-bpm-d-sharp-min-smokmimi.mp3",
    "source": "Southside Trap/146 Bpm D# Min (Smokmimi).mp3"
  },
  {
    "id": "melodic-trap/160-bpm-c-min-future-damar",
    "title": "160 Bpm C Min (Future Damar)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/160-bpm-c-min-future-damar.mp3",
    "source": "Melodic Trap/160 Bpm C Min (Future Damar).mp3"
  },
  {
    "id": "southside-trap/128-bpm-f-min-soul",
    "title": "128 Bpm F Min (Soul )",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/128-bpm-f-min-soul.mp3",
    "source": "Southside Trap/128 Bpm F Min (Soul-).mp3"
  },
  {
    "id": "zateviss/143-bpm-f-min-lo-bra",
    "title": "143 Bpm F Min (Lo Bra)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/143-bpm-f-min-lo-bra.mp3",
    "source": "Zateviss/143 Bpm F Min (Lo-Bra).mp3"
  },
  {
    "id": "southside-trap/160-bpm-e-min-sleep",
    "title": "160 Bpm E Min (Sleep)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/160-bpm-e-min-sleep.mp3",
    "source": "Southside Trap/160 Bpm E Min (Sleep).mp3"
  },
  {
    "id": "90s/90-bpm-d-min-gaz",
    "title": "90 bpm D Min (GAZ)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/90-bpm-d-min-gaz.mp3",
    "source": "90's/90 bpm D Min (GAZ).mp3"
  },
  {
    "id": "southside-trap/150-bpm-c-min-nexx-up",
    "title": "150 Bpm C Min (Nexx Up)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/150-bpm-c-min-nexx-up.mp3",
    "source": "Southside Trap/150 Bpm C Min (Nexx Up).mp3"
  },
  {
    "id": "dance-music/130-bpm-c-min-dalga-x-deep",
    "title": "130 Bpm C Min (dalga x deep)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/130-bpm-c-min-dalga-x-deep.mp3",
    "source": "Dance Music/130 Bpm C Min (dalga x deep).mp3"
  },
  {
    "id": "melodic-trap/110-bpm-d-min-wheezy",
    "title": "110 Bpm D Min (Wheezy)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/110-bpm-d-min-wheezy.mp3",
    "source": "Melodic Trap/110 Bpm D Min (Wheezy).mp3"
  },
  {
    "id": "pluggnb-rage/163-bpm-e-min-beniyex",
    "title": "163 Bpm E Min (BENIYEX)",
    "type": "Pluggnb & Rage",
    "genre": "Pluggnb & Rage",
    "key": "beats/pluggnb-rage/163-bpm-e-min-beniyex.mp3",
    "source": "Pluggnb & Rage/163 Bpm E Min (BENIYEX).mp3"
  },
  {
    "id": "melodic-trap/168-bpm-d-sharp-min-fuckin-canvas",
    "title": "168 Bpm D# Min (Fuckin Canvas)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/168-bpm-d-sharp-min-fuckin-canvas.mp3",
    "source": "Melodic Trap/168 Bpm D# Min (Fuckin Canvas).mp3"
  },
  {
    "id": "melodic-trap/117-bpm-d-sharp-min-embarrassed",
    "title": "117 Bpm D# Min (Embarrassed)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/117-bpm-d-sharp-min-embarrassed.mp3",
    "source": "Melodic Trap/117 Bpm D# Min (Embarrassed).mp3"
  },
  {
    "id": "melodic-trap/134-bpm-d-min-dizzee-rascal",
    "title": "134 Bpm D Min (Dizzee Rascal)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/134-bpm-d-min-dizzee-rascal.mp3",
    "source": "Melodic Trap/134 Bpm D Min (Dizzee Rascal).mp3"
  },
  {
    "id": "southside-trap/155-bpm-c-sharp-min-i-do-not-do-haram",
    "title": "155 Bpm C# Min (I Do Not Do Haram)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/155-bpm-c-sharp-min-i-do-not-do-haram.mp3",
    "source": "Southside Trap/155 Bpm C# Min (I Do Not Do Haram).mp3"
  },
  {
    "id": "dance-music/102-bpm-e-min-uyusturucu-adam",
    "title": "102 Bpm E Min (Uyusturucu Adam)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/102-bpm-e-min-uyusturucu-adam.mp3",
    "source": "Dance Music/102 Bpm E Min (Uyusturucu Adam).mp3"
  },
  {
    "id": "southside-trap/142-bpm-f-sharp-min-maximum-shit",
    "title": "142 Bpm F# Min (Maximum shit)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/142-bpm-f-sharp-min-maximum-shit.mp3",
    "source": "Southside Trap/142 Bpm F# Min (Maximum shit).mp3"
  },
  {
    "id": "melodic-trap/156-bpm-f-sharp-min-cyber",
    "title": "156 Bpm F# Min (Cyber)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/156-bpm-f-sharp-min-cyber.mp3",
    "source": "Melodic Trap/156 Bpm F# Min (Cyber).mp3"
  },
  {
    "id": "zateviss/180-bpm-f-min-drivebymysoul",
    "title": "180 Bpm F Min (DriveByMySoul)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/180-bpm-f-min-drivebymysoul.mp3",
    "source": "Zateviss/180 Bpm F Min (DriveByMySoul).mp3"
  },
  {
    "id": "zateviss/140-bpm-d-min-r-se",
    "title": "140 Bpm D Min (R!SE)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/140-bpm-d-min-r-se.mp3",
    "source": "Zateviss/140 Bpm D Min (R!SE).mp3"
  },
  {
    "id": "hoodtrap/138-bpm-c-min-dark-hoodtrap",
    "title": "138 Bpm C Min (Dark Hoodtrap)",
    "type": "Hoodtrap",
    "genre": "Hoodtrap",
    "key": "beats/hoodtrap/138-bpm-c-min-dark-hoodtrap.mp3",
    "source": "Hoodtrap/138 Bpm C Min (Dark Hoodtrap).mp3"
  },
  {
    "id": "diger/136-bpm-e-min-don-t-say-a-word",
    "title": "136 Bpm E Min (Don t Say A Word)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/136-bpm-e-min-don-t-say-a-word.mp3",
    "source": "Diğer/136 Bpm E Min (Don_t Say A Word).mp3"
  },
  {
    "id": "melodic-trap/210-bpm-f-sharp-min-bir-atese-attin",
    "title": "210 Bpm F# Min (Bir Ateşe Attın)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/210-bpm-f-sharp-min-bir-atese-attin.mp3",
    "source": "Melodic Trap/210 Bpm F# Min (Bir Ateşe Attın).mp3"
  },
  {
    "id": "southside-trap/127-bpm-d-min-dea-min",
    "title": "127 Bpm D Min (Dea min)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/127-bpm-d-min-dea-min.mp3",
    "source": "Southside Trap/127 Bpm D Min (Dea min).mp3"
  },
  {
    "id": "pluggnb-rage/155-bpm-f-min-dehhaa2",
    "title": "155 Bpm F Min (Dehhaa2)",
    "type": "Pluggnb & Rage",
    "genre": "Pluggnb & Rage",
    "key": "beats/pluggnb-rage/155-bpm-f-min-dehhaa2.mp3",
    "source": "Pluggnb & Rage/155 Bpm F Min (Dehhaa2).mp3"
  },
  {
    "id": "zateviss/130-bpm-e-harmonic-dune-to-trav",
    "title": "130 Bpm E Harmonic (Dune To Trav)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/130-bpm-e-harmonic-dune-to-trav.mp3",
    "source": "Zateviss/130 Bpm E Harmonic (Dune To Trav).mp3"
  },
  {
    "id": "southside-trap/120-bpm-f-sharp-min-future-orchestral-intro",
    "title": "120 Bpm F# Min (Future Orchestral Intro)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/120-bpm-f-sharp-min-future-orchestral-intro.mp3",
    "source": "Southside Trap/120 Bpm F# Min (Future Orchestral Intro).mp3"
  },
  {
    "id": "melodic-trap/166-bpm-f-min-edge",
    "title": "166 Bpm F Min (Edge)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/166-bpm-f-min-edge.mp3",
    "source": "Melodic Trap/166 Bpm F Min (Edge).mp3"
  },
  {
    "id": "southside-trap/180-bpm-c-min-step-step",
    "title": "180 Bpm C Min (StepßStep)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/180-bpm-c-min-step-step.mp3",
    "source": "Southside Trap/180 Bpm C Min (StepßStep).mp3"
  },
  {
    "id": "zateviss/120-bpm-d-min-babaa",
    "title": "120 Bpm D Min (Babaa)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/120-bpm-d-min-babaa.mp3",
    "source": "Zateviss/120 Bpm D Min (Babaa).mp3"
  },
  {
    "id": "zateviss/140-bpm-g-sharp-min-reels-x-tavian-d-petitt",
    "title": "140 Bpm G# Min (Reels x Tavian d. Petitt )",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/140-bpm-g-sharp-min-reels-x-tavian-d-petitt.mp3",
    "source": "Zateviss/140 Bpm G# Min (Reels x Tavian d. Petitt ).mp3"
  },
  {
    "id": "dance-music/113-bpm-c-sharp-min-draggaeton",
    "title": "113 Bpm C# Min (Draggaeton)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/113-bpm-c-sharp-min-draggaeton.mp3",
    "source": "Dance Music/113 Bpm C# Min (Draggaeton).mp3"
  },
  {
    "id": "southside-trap/130-bpm-d-min-to-lil-baby-x-future",
    "title": "130 Bpm D Min (To Lil Baby x Future)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/130-bpm-d-min-to-lil-baby-x-future.mp3",
    "source": "Southside Trap/130 Bpm D Min (To Lil Baby x Future).mp3"
  },
  {
    "id": "southside-trap/163-bpm-e-min-rip-v",
    "title": "163 Bpm E Min (RIP V)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/163-bpm-e-min-rip-v.mp3",
    "source": "Southside Trap/163 Bpm E Min (RIP V).mp3"
  },
  {
    "id": "hoodtrap/134-bpm-a-min-aquafina-type",
    "title": "134 Bpm A Min (Aquafina Type)",
    "type": "Hoodtrap",
    "genre": "Hoodtrap",
    "key": "beats/hoodtrap/134-bpm-a-min-aquafina-type.mp3",
    "source": "Hoodtrap/134 Bpm A Min (Aquafina Type).mp3"
  },
  {
    "id": "dance-music/128-bpm-g-min-first-c-ozur",
    "title": "128 Bpm G Min (First C Özür)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/128-bpm-g-min-first-c-ozur.mp3",
    "source": "Dance Music/128 Bpm G Min (First C Özür).mp3"
  },
  {
    "id": "dance-music/125-bpm-a-sharp-min-hasgitar",
    "title": "125 Bpm A# Min (Hasgitar)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/125-bpm-a-sharp-min-hasgitar.mp3",
    "source": "Dance Music/125 Bpm A# Min (Hasgitar).mp3"
  },
  {
    "id": "southside-trap/197-bpm-c-min-yaramaz",
    "title": "197 Bpm C Min (Yaramaz)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/197-bpm-c-min-yaramaz.mp3",
    "source": "Southside Trap/197 Bpm C Min (Yaramaz).mp3"
  },
  {
    "id": "zateviss/118-bpm-c-min-dawn",
    "title": "118 Bpm C Min (Dawn)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/118-bpm-c-min-dawn.mp3",
    "source": "Zateviss/118 Bpm C Min (Dawn).mp3"
  },
  {
    "id": "melodic-trap/170-bpm-c-sharp-min-fast",
    "title": "170 Bpm C# Min (Fast)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/170-bpm-c-sharp-min-fast.mp3",
    "source": "Melodic Trap/170 Bpm C# Min (Fast).mp3"
  },
  {
    "id": "dance-music/125-bpm-c-sharp-min-www",
    "title": "125 Bpm C# Min (WWW)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/125-bpm-c-sharp-min-www.mp3",
    "source": "Dance Music/125 Bpm C# Min (WWW).mp3"
  },
  {
    "id": "southside-trap/150-bpm-c-maj-duhuh",
    "title": "150 Bpm C Maj (Duhuh)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/150-bpm-c-maj-duhuh.mp3",
    "source": "Southside Trap/150 Bpm C Maj (Duhuh).mp3"
  },
  {
    "id": "melodic-trap/72-bpm-f-sharp-min-remember",
    "title": "72 Bpm F# Min (Remember)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/72-bpm-f-sharp-min-remember.mp3",
    "source": "Melodic Trap/72 Bpm F# Min (Remember).mp3"
  },
  {
    "id": "southside-trap/132-bpm-c-sharp-min-fetti",
    "title": "132 Bpm C# Min (Fetti)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/132-bpm-c-sharp-min-fetti.mp3",
    "source": "Southside Trap/132 Bpm C# Min (Fetti).mp3"
  },
  {
    "id": "melodic-trap/135-bpm-d-min-leavesloco",
    "title": "135 Bpm D Min (LeavesLoco)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/135-bpm-d-min-leavesloco.mp3",
    "source": "Melodic Trap/135 Bpm D Min (LeavesLoco).mp3"
  },
  {
    "id": "melodic-trap/126-bpm-d-min-gunna-x-feragat",
    "title": "126 Bpm D min (Gunna x Feragat)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/126-bpm-d-min-gunna-x-feragat.mp3",
    "source": "Melodic Trap/126 Bpm D min (Gunna x Feragat).mp3"
  },
  {
    "id": "zateviss/100-200-bpm-d-sharp-min-1-1-10",
    "title": "100 200 Bpm D# Min (1+1=10)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/100-200-bpm-d-sharp-min-1-1-10.mp3",
    "source": "Zateviss/100-200 Bpm D# Min (1+1=10).mp3"
  },
  {
    "id": "melodic-trap/130-bpm-d-sharp-min-still-same",
    "title": "130 Bpm D# Min (Still Same)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/130-bpm-d-sharp-min-still-same.mp3",
    "source": "Melodic Trap/130 Bpm D# Min (Still Same).mp3"
  },
  {
    "id": "southside-trap/140-bpm-c-sharp-min-taj-mahal-pyrex",
    "title": "140 Bpm C# Min (Taj Mahal Pyrex)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/140-bpm-c-sharp-min-taj-mahal-pyrex.mp3",
    "source": "Southside Trap/140 Bpm C# Min (Taj Mahal Pyrex).mp3"
  },
  {
    "id": "diger/120-bpm-c-min-ldr",
    "title": "120 Bpm C Min (LDR)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/120-bpm-c-min-ldr.mp3",
    "source": "Diğer/120 Bpm C Min (LDR).mp3"
  },
  {
    "id": "zateviss/120-bpm-f-sharp-min-white-roses",
    "title": "120 Bpm F# Min (White Roses)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/120-bpm-f-sharp-min-white-roses.mp3",
    "source": "Zateviss/120 Bpm F# Min (White Roses).mp3"
  },
  {
    "id": "zateviss/133-bpm-d-sharp-min-dogu-tarafi",
    "title": "133 Bpm D# Min (Doğu Tarafı)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/133-bpm-d-sharp-min-dogu-tarafi.mp3",
    "source": "Zateviss/133 Bpm D# Min (Doğu Tarafı).mp3"
  },
  {
    "id": "ambient/147-bpm-f-sharp-maj-yesiloda",
    "title": "147 Bpm F# Maj (YesilOda)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/147-bpm-f-sharp-maj-yesiloda.mp3",
    "source": "Ambient/147 Bpm F# Maj (YesilOda).mp3"
  },
  {
    "id": "southside-trap/130-bpm-c-sharp-min-future-x-sf2",
    "title": "130 Bpm C# Min (Future x SF2)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/130-bpm-c-sharp-min-future-x-sf2.mp3",
    "source": "Southside Trap/130 Bpm C# Min (Future x SF2).mp3"
  },
  {
    "id": "dance-music/132-bpm-g-sharp-min-morad-first",
    "title": "132 Bpm G# Min (Morad First)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/132-bpm-g-sharp-min-morad-first.mp3",
    "source": "Dance Music/132 Bpm G# Min (Morad First).mp3"
  },
  {
    "id": "zateviss/165-bpm-d-sharp-maj-nothing",
    "title": "165 Bpm D# Maj (Nothing)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/165-bpm-d-sharp-maj-nothing.mp3",
    "source": "Zateviss/165 Bpm D# Maj (Nothing).mp3"
  },
  {
    "id": "pluggnb-rage/152-bpm-d-sharp-maj-edit",
    "title": "152 Bpm D# Maj (Edit)",
    "type": "Pluggnb & Rage",
    "genre": "Pluggnb & Rage",
    "key": "beats/pluggnb-rage/152-bpm-d-sharp-maj-edit.mp3",
    "source": "Pluggnb & Rage/152 Bpm D# Maj (Edit).mp3"
  },
  {
    "id": "zateviss/137-bpm-c-min-serd",
    "title": "137 Bpm C Min (Serd)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/137-bpm-c-min-serd.mp3",
    "source": "Zateviss/137 Bpm C Min (Serd).mp3"
  },
  {
    "id": "southside-trap/180-bpm-d-sharp-min-ea",
    "title": "180 Bpm D# Min (EA)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/180-bpm-d-sharp-min-ea.mp3",
    "source": "Southside Trap/180 Bpm D# Min (EA).mp3"
  },
  {
    "id": "diger/148-bpm-c-maj-runnin-x-jersey",
    "title": "148 Bpm C Maj (Runnin x Jersey)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/148-bpm-c-maj-runnin-x-jersey.mp3",
    "source": "Diğer/148 Bpm C Maj (Runnin x Jersey).mp3"
  },
  {
    "id": "hoodtrap/145-bpm-d-min-hoodtrap-she-knows",
    "title": "145 Bpm D Min (Hoodtrap   She Knows)",
    "type": "Hoodtrap",
    "genre": "Hoodtrap",
    "key": "beats/hoodtrap/145-bpm-d-min-hoodtrap-she-knows.mp3",
    "source": "Hoodtrap/145 Bpm D Min (Hoodtrap - She Knows).mp3"
  },
  {
    "id": "melodic-trap/105-bpm-f-sharp-min-knievel",
    "title": "105 Bpm F# Min (Knievel)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/105-bpm-f-sharp-min-knievel.mp3",
    "source": "Melodic Trap/105 Bpm F# Min (Knievel).mp3"
  },
  {
    "id": "melodic-trap/97-bpm-e-min-count-me",
    "title": "97 Bpm E Min (Count Me)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/97-bpm-e-min-count-me.mp3",
    "source": "Melodic Trap/97 Bpm E Min (Count Me).mp3"
  },
  {
    "id": "dance-music/122-bpm-a-sharp-maj-morad-x-deephouse",
    "title": "122 Bpm A# Maj (Morad x Deephouse)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/122-bpm-a-sharp-maj-morad-x-deephouse.mp3",
    "source": "Dance Music/122 Bpm A# Maj (Morad x Deephouse).mp3"
  },
  {
    "id": "pluggnb-rage/135-bpm-c-min-swervv",
    "title": "135 Bpm C Min (Swervv)",
    "type": "Pluggnb & Rage",
    "genre": "Pluggnb & Rage",
    "key": "beats/pluggnb-rage/135-bpm-c-min-swervv.mp3",
    "source": "Pluggnb & Rage/135 Bpm C Min (Swervv).mp3"
  },
  {
    "id": "melodic-trap/115-bpm-c-sharp-min-national",
    "title": "115 Bpm C# Min (National)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/115-bpm-c-sharp-min-national.mp3",
    "source": "Melodic Trap/115 Bpm C# Min (National).mp3"
  },
  {
    "id": "90s/95-bpm-c-sharp-min-50-cent-x-dr-dre",
    "title": "95 Bpm C# Min (50 cent x Dr.dre)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/95-bpm-c-sharp-min-50-cent-x-dr-dre.mp3",
    "source": "90's/95 Bpm C# Min (50 cent x Dr.dre).mp3"
  },
  {
    "id": "melodic-trap/160-bpm-f-sharp-min-bang-bang",
    "title": "160 Bpm F# Min (Bang Bang)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/160-bpm-f-sharp-min-bang-bang.mp3",
    "source": "Melodic Trap/160 Bpm F# Min (Bang Bang).mp3"
  },
  {
    "id": "melodic-trap/125-bpm-c-sharp-maj-rew",
    "title": "125 Bpm C# Maj (Rew)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/125-bpm-c-sharp-maj-rew.mp3",
    "source": "Melodic Trap/125 Bpm C# Maj (Rew).mp3"
  },
  {
    "id": "melodic-trap/158-bpm-e-min-limit-yok",
    "title": "158 Bpm E Min (Limit Yok)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/158-bpm-e-min-limit-yok.mp3",
    "source": "Melodic Trap/158 Bpm E Min (Limit Yok).mp3"
  },
  {
    "id": "diger/162-bpm-c-min-in-the-middle-of-fear",
    "title": "162 Bpm C Min (In The Middle Of Fear)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/162-bpm-c-min-in-the-middle-of-fear.mp3",
    "source": "Diğer/162 Bpm C Min (In The Middle Of Fear).mp3"
  },
  {
    "id": "90s/93-bpm-f-sharp-min-modesty",
    "title": "93 Bpm F# Min (Modesty)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/93-bpm-f-sharp-min-modesty.mp3",
    "source": "90's/93 Bpm F# Min (Modesty).mp3"
  },
  {
    "id": "ambient/136-bpm-e-min-dont-say-a-word",
    "title": "136 Bpm E Min (Don't Say A Word)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/136-bpm-e-min-dont-say-a-word.mp3",
    "source": "Ambient/136 Bpm E Min (Don't Say A Word).mp3"
  },
  {
    "id": "dance-music/130-bpm-baby-back-brasil",
    "title": "130 Bpm (Baby Back Brasil)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/130-bpm-baby-back-brasil.mp3",
    "source": "Dance Music/130 Bpm (Baby Back Brasil).mp3"
  },
  {
    "id": "dance-music/138-bpm-f-sharp-maj-brazil-x-bvtu",
    "title": "138 Bpm F# maj (brazil x bvtu).",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/138-bpm-f-sharp-maj-brazil-x-bvtu.mp3",
    "source": "Dance Music/138 Bpm F# maj (brazil x bvtu)..mp3"
  },
  {
    "id": "melodic-trap/95-bpm-c-min-duygusal-gitar-piyano",
    "title": "95 Bpm C Min (Duygusal Gitar & Piyano)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/95-bpm-c-min-duygusal-gitar-piyano.mp3",
    "source": "Melodic Trap/95 Bpm C Min (Duygusal Gitar & Piyano).mp3"
  },
  {
    "id": "dance-music/127-bpm-f-sharp-min-sumsum",
    "title": "127 Bpm F# Min (SumSum)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/127-bpm-f-sharp-min-sumsum.mp3",
    "source": "Dance Music/127 Bpm F# Min (SumSum).mp3"
  },
  {
    "id": "hoodtrap/190-bpm-c-esdeekid-x-fakemink-type",
    "title": "190 Bpm C (Esdeekid x Fakemink Type)",
    "type": "Hoodtrap",
    "genre": "Hoodtrap",
    "key": "beats/hoodtrap/190-bpm-c-esdeekid-x-fakemink-type.mp3",
    "source": "Hoodtrap/190 Bpm C (Esdeekid x Fakemink Type).mp3"
  },
  {
    "id": "melodic-trap/93-bpm-d-sharp-min-duygusal-keman-x-sax",
    "title": "93 Bpm D# Min (Duygusal Keman x Sax)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/93-bpm-d-sharp-min-duygusal-keman-x-sax.mp3",
    "source": "Melodic Trap/93 Bpm D# Min (Duygusal Keman x Sax).mp3"
  },
  {
    "id": "90s/97-bpm-c-sharp-maj-balkanss",
    "title": "97 Bpm C# Maj (Balkanss)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/97-bpm-c-sharp-maj-balkanss.mp3",
    "source": "90's/97 Bpm C# Maj (Balkanss).mp3"
  },
  {
    "id": "melodic-trap/130-bpm-d-sharp-min-no-mo",
    "title": "130 Bpm D# Min (No Mo)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/130-bpm-d-sharp-min-no-mo.mp3",
    "source": "Melodic Trap/130 Bpm D# Min (No Mo).mp3"
  },
  {
    "id": "ambient/100-bpm-f-min-miyagi",
    "title": "100 Bpm F Min (Miyagi)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/100-bpm-f-min-miyagi.mp3",
    "source": "Ambient/100 Bpm F Min (Miyagi).mp3"
  },
  {
    "id": "melodic-trap/175-bpm-f-maj-bretheren",
    "title": "175 Bpm F Maj (Bretheren)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/175-bpm-f-maj-bretheren.mp3",
    "source": "Melodic Trap/175 Bpm F Maj (Bretheren).mp3"
  },
  {
    "id": "pluggnb-rage/125-bpm-f-min-hphphp",
    "title": "125 Bpm F Min (HpHpHp)",
    "type": "Pluggnb & Rage",
    "genre": "Pluggnb & Rage",
    "key": "beats/pluggnb-rage/125-bpm-f-min-hphphp.mp3",
    "source": "Pluggnb & Rage/125 Bpm F Min (HpHpHp).mp3"
  },
  {
    "id": "90s/95-bpm-c-sharp-min-bboys",
    "title": "95 Bpm C# Min (BBoys)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/95-bpm-c-sharp-min-bboys.mp3",
    "source": "90's/95 Bpm C# Min (BBoys).mp3"
  },
  {
    "id": "melodic-trap/175-bpm-c-min-80kick",
    "title": "175 Bpm C Min (80Kick)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/175-bpm-c-min-80kick.mp3",
    "source": "Melodic Trap/175 Bpm C Min (80Kick).mp3"
  },
  {
    "id": "melodic-trap/182-bpm-a-min-fam-business",
    "title": "182 Bpm A Min (Fam Business)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/182-bpm-a-min-fam-business.mp3",
    "source": "Melodic Trap/182 Bpm A Min (Fam Business).mp3"
  },
  {
    "id": "melodic-trap/95-bpm-c-sharp-min-babygang-x-turkish-emotional",
    "title": "95 Bpm C# Min (Babygang x Turkish Emotional)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/95-bpm-c-sharp-min-babygang-x-turkish-emotional.mp3",
    "source": "Melodic Trap/95 Bpm C# Min (Babygang x Turkish Emotional).mp3"
  },
  {
    "id": "zateviss/120-bpm-c-sharp-maj-sike",
    "title": "120 Bpm C# Maj (SIKE!)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/120-bpm-c-sharp-maj-sike.mp3",
    "source": "Zateviss/120 Bpm C# Maj (SIKE!).mp3"
  },
  {
    "id": "melodic-trap/135-bpm-c-sharp-min-tear",
    "title": "135 Bpm C# Min (Tear)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/135-bpm-c-sharp-min-tear.mp3",
    "source": "Melodic Trap/135 Bpm C# Min (Tear).mp3"
  },
  {
    "id": "diger/130-bpm-c-sharp-min-yeat-x-dubstep",
    "title": "130 Bpm C# Min (Yeat x Dubstep)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/130-bpm-c-sharp-min-yeat-x-dubstep.mp3",
    "source": "Diğer/130 Bpm C# Min (Yeat x Dubstep).mp3"
  },
  {
    "id": "zateviss/128-bpm-c-sharp-min-tickin",
    "title": "128 Bpm C# Min (Tickin)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/128-bpm-c-sharp-min-tickin.mp3",
    "source": "Zateviss/128 Bpm C# Min (Tickin).mp3"
  },
  {
    "id": "90s/100-bpm-d-sharp-min-sarmalik",
    "title": "100 Bpm D# Min (Sarmalık)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/100-bpm-d-sharp-min-sarmalik.mp3",
    "source": "90's/100 Bpm D# Min (Sarmalık).mp3"
  },
  {
    "id": "melodic-trap/164-bpm-e-min-lavern",
    "title": "164 Bpm E Min (Lavern)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/164-bpm-e-min-lavern.mp3",
    "source": "Melodic Trap/164 Bpm E Min (Lavern).mp3"
  },
  {
    "id": "90s/90-bpm-a-min-inaccessibility",
    "title": "90 Bpm A Min (Inaccessibility)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/90-bpm-a-min-inaccessibility.mp3",
    "source": "90's/90 Bpm A Min (Inaccessibility).mp3"
  },
  {
    "id": "southside-trap/150-bpm-d-min-e-wickedddd",
    "title": "150 Bpm D Min (E Wickedddd)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/150-bpm-d-min-e-wickedddd.mp3",
    "source": "Southside Trap/150 Bpm D Min (E-Wickedddd).mp3"
  },
  {
    "id": "melodic-trap/165-bpm-c-sharp-gel-bahtimin-kar-beyazi",
    "title": "165 Bpm C# (Gel Bahtımın Kar Beyazı)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/165-bpm-c-sharp-gel-bahtimin-kar-beyazi.mp3",
    "source": "Melodic Trap/165 Bpm C# (Gel Bahtımın Kar Beyazı).mp3"
  },
  {
    "id": "zateviss/165-bpm-c-sharp-gel-bahtimin-kar-beyazi",
    "title": "165 Bpm C# (Gel Bahtımın Kar Beyazı)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/165-bpm-c-sharp-gel-bahtimin-kar-beyazi.mp3",
    "source": "Zateviss/165 Bpm C# (Gel Bahtımın Kar Beyazı).mp3"
  },
  {
    "id": "melodic-trap/155-bpm-e-min-lasng",
    "title": "155 Bpm E Min (Lasng)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/155-bpm-e-min-lasng.mp3",
    "source": "Melodic Trap/155 Bpm E Min (Lasng).mp3"
  },
  {
    "id": "southside-trap/170-bpm-c-sharp-min-baby-nardo",
    "title": "170 Bpm C# Min (Baby Nardo)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/170-bpm-c-sharp-min-baby-nardo.mp3",
    "source": "Southside Trap/170 Bpm C# Min (Baby Nardo).mp3"
  },
  {
    "id": "ambient/150-bpm-d-min-don-t-blink",
    "title": "150 Bpm D Min (Don t Blink)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/150-bpm-d-min-don-t-blink.mp3",
    "source": "Ambient/150 Bpm D Min (Don_t Blink).mp3"
  },
  {
    "id": "melodic-trap/115-bpm-e-min-future-guitar",
    "title": "115 Bpm E Min (Future Guitar)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/115-bpm-e-min-future-guitar.mp3",
    "source": "Melodic Trap/115 Bpm E Min (Future Guitar).mp3"
  },
  {
    "id": "southside-trap/166-bpm-c-sharp-min-igr",
    "title": "166 Bpm C# Min (IGR)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/166-bpm-c-sharp-min-igr.mp3",
    "source": "Southside Trap/166 Bpm C# Min (IGR).mp3"
  },
  {
    "id": "90s/95-bpm-c-min-cha-cha",
    "title": "95 Bpm C Min (Cha Cha)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/95-bpm-c-min-cha-cha.mp3",
    "source": "90's/95 Bpm C Min (Cha Cha).mp3"
  },
  {
    "id": "zateviss/180-bpm-d-sharp-min-geregere",
    "title": "180 Bpm D# Min (GereGere)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/180-bpm-d-sharp-min-geregere.mp3",
    "source": "Zateviss/180 Bpm D# Min (GereGere).mp3"
  },
  {
    "id": "melodic-trap/120-bpm-d-min-kurtuldum",
    "title": "120 Bpm D Min (Kurtuldum)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/120-bpm-d-min-kurtuldum.mp3",
    "source": "Melodic Trap/120 Bpm D Min (Kurtuldum).mp3"
  },
  {
    "id": "melodic-trap/115-bpm-d-sharp-min-god-with-diion",
    "title": "115 Bpm D# min (GOD with Diion)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/115-bpm-d-sharp-min-god-with-diion.mp3",
    "source": "Melodic Trap/115 Bpm D# min (GOD with Diion).mp3"
  },
  {
    "id": "diger/140-bpm-c-min-not-from-this-world",
    "title": "140 Bpm C Min (Not from this world)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/140-bpm-c-min-not-from-this-world.mp3",
    "source": "Diğer/140 Bpm C Min (Not from this world).mp3"
  },
  {
    "id": "dance-music/130-bpm-e-min-ln-drive",
    "title": "130 Bpm E Min (LN Drive)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/130-bpm-e-min-ln-drive.mp3",
    "source": "Dance Music/130 Bpm E Min (LN Drive).mp3"
  },
  {
    "id": "diger/120-bpm-c-sharp-maj-sike",
    "title": "120 Bpm C# Maj (SIKE!)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/120-bpm-c-sharp-maj-sike.mp3",
    "source": "Diğer/120 Bpm C# Maj (SIKE!).mp3"
  },
  {
    "id": "zateviss/148-bpm-d-sharp-min-ai-too-broken",
    "title": "148 Bpm D# Min (AI too Broken)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/148-bpm-d-sharp-min-ai-too-broken.mp3",
    "source": "Zateviss/148 Bpm D# Min (AI too Broken).mp3"
  },
  {
    "id": "dance-music/143-bpm-f-min-lo-bra",
    "title": "143 Bpm F Min (Lo Bra)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/143-bpm-f-min-lo-bra.mp3",
    "source": "Dance Music/143 Bpm F Min (Lo-Bra).mp3"
  },
  {
    "id": "melodic-trap/160-bpm-e-min-jimmy-knucks",
    "title": "160 Bpm E Min (Jimmy Knucks)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/160-bpm-e-min-jimmy-knucks.mp3",
    "source": "Melodic Trap/160 Bpm E Min (Jimmy Knucks).mp3"
  },
  {
    "id": "southside-trap/145-bpm-c-sharp-min-ww",
    "title": "145 Bpm C# Min (WW)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/145-bpm-c-sharp-min-ww.mp3",
    "source": "Southside Trap/145 Bpm C# Min (WW).mp3"
  },
  {
    "id": "pluggnb-rage/160-bpm-g-sharp-min-deeeeeeeeeeeeeeeeeeeha",
    "title": "160 Bpm G# Min (Deeeeeeeeeeeeeeeeeeeha)",
    "type": "Pluggnb & Rage",
    "genre": "Pluggnb & Rage",
    "key": "beats/pluggnb-rage/160-bpm-g-sharp-min-deeeeeeeeeeeeeeeeeeeha.mp3",
    "source": "Pluggnb & Rage/160 Bpm G# Min (Deeeeeeeeeeeeeeeeeeeha).mp3"
  },
  {
    "id": "zateviss/85-bpm-e-min-ege-cube-x-erkin-coray",
    "title": "85 Bpm E Min (Ege Cube x Erkin Coray)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/85-bpm-e-min-ege-cube-x-erkin-coray.mp3",
    "source": "Zateviss/85 Bpm E Min (Ege Cube x Erkin Coray).mp3"
  },
  {
    "id": "melodic-trap/131-bpm-f-min-west",
    "title": "131 Bpm F Min (West)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/131-bpm-f-min-west.mp3",
    "source": "Melodic Trap/131 Bpm F Min (West).mp3"
  },
  {
    "id": "zateviss/138-bpm-d-maj-bana-sorr",
    "title": "138 Bpm D Maj (Bana sorr)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/138-bpm-d-maj-bana-sorr.mp3",
    "source": "Zateviss/138 Bpm D Maj (Bana sorr).mp3"
  },
  {
    "id": "southside-trap/105-bpm-d-sharp-min-fresh-off-the-weekend",
    "title": "105 Bpm D# Min (Fresh Off the Weekend)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/105-bpm-d-sharp-min-fresh-off-the-weekend.mp3",
    "source": "Southside Trap/105 Bpm D# Min (Fresh Off the Weekend).mp3"
  },
  {
    "id": "dance-music/130-bpm-g-min-dididing",
    "title": "130 Bpm G Min (Dididing)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/130-bpm-g-min-dididing.mp3",
    "source": "Dance Music/130 Bpm G Min (Dididing).mp3"
  },
  {
    "id": "melodic-trap/180-bpm-f-minor-californication-x-polo-g",
    "title": "180 Bpm F Minor (Californication x Polo g)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/180-bpm-f-minor-californication-x-polo-g.mp3",
    "source": "Melodic Trap/180 Bpm F Minor (Californication x Polo g).mp3"
  },
  {
    "id": "zateviss/94-bpm-a-sharp-maj-hy-salvador",
    "title": "94 Bpm A# Maj (HY Salvador)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/94-bpm-a-sharp-maj-hy-salvador.mp3",
    "source": "Zateviss/94 Bpm A# Maj (HY Salvador).mp3"
  },
  {
    "id": "zateviss/160-bpm-f-min-dcore",
    "title": "160 Bpm F Min (DCore)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/160-bpm-f-min-dcore.mp3",
    "source": "Zateviss/160 Bpm F Min (DCore).mp3"
  },
  {
    "id": "diger/152-bpm-g-min-ethereal-x-don-t",
    "title": "152 Bpm G Min (Ethereal x Don T)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/152-bpm-g-min-ethereal-x-don-t.mp3",
    "source": "Diğer/152 Bpm G Min (Ethereal x Don T).mp3"
  },
  {
    "id": "melodic-trap/123-bpm-g-min-korkma",
    "title": "123 Bpm G Min (Korkma)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/123-bpm-g-min-korkma.mp3",
    "source": "Melodic Trap/123 Bpm G Min (Korkma).mp3"
  },
  {
    "id": "diger/135-bpm-g-sharp-min-ugg-a",
    "title": "135 Bpm G# Min (Ugg a)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/135-bpm-g-sharp-min-ugg-a.mp3",
    "source": "Diğer/135 Bpm G# Min (Ugg_a).mp3"
  },
  {
    "id": "dance-music/125-bpm-e-min-stodida",
    "title": "125 Bpm E Min (StoDida)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/125-bpm-e-min-stodida.mp3",
    "source": "Dance Music/125 Bpm E Min (StoDida).mp3"
  },
  {
    "id": "melodic-trap/180-bpm-c-min-careless",
    "title": "180 Bpm C Min (Careless)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/180-bpm-c-min-careless.mp3",
    "source": "Melodic Trap/180 Bpm C Min (Careless).mp3"
  },
  {
    "id": "melodic-trap/170-bpm-d-maj-saint-preux",
    "title": "170 Bpm D Maj (Saint Preux)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/170-bpm-d-maj-saint-preux.mp3",
    "source": "Melodic Trap/170 Bpm D Maj (Saint-Preux).mp3"
  },
  {
    "id": "melodic-trap/180-bpm-c-sharp-min-no-ordinary-love",
    "title": "180 Bpm C# Min (No Ordinary Love)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/180-bpm-c-sharp-min-no-ordinary-love.mp3",
    "source": "Melodic Trap/180 Bpm C# Min (No Ordinary Love).mp3"
  },
  {
    "id": "southside-trap/141-bpm-f-sharp-min-amen",
    "title": "141 Bpm F# Min (Amen)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/141-bpm-f-sharp-min-amen.mp3",
    "source": "Southside Trap/141 Bpm F# Min (Amen).mp3"
  },
  {
    "id": "dance-music/125-bpm-e-min-dar-alan",
    "title": "125 Bpm E Min (Dar alan)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/125-bpm-e-min-dar-alan.mp3",
    "source": "Dance Music/125 Bpm E Min (Dar alan).mp3"
  },
  {
    "id": "southside-trap/135-bpm-c-sharp-min-p-in-they-face",
    "title": "135 Bpm C# Min (P in They Face)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/135-bpm-c-sharp-min-p-in-they-face.mp3",
    "source": "Southside Trap/135 Bpm C# Min (P in They Face).mp3"
  },
  {
    "id": "melodic-trap/110-bpm-e-min-success",
    "title": "110 Bpm E Min (Success)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/110-bpm-e-min-success.mp3",
    "source": "Melodic Trap/110 Bpm E Min (Success).mp3"
  },
  {
    "id": "southside-trap/130-bpm-e-min-fam-free",
    "title": "130 Bpm E Min (Fam Free)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/130-bpm-e-min-fam-free.mp3",
    "source": "Southside Trap/130 Bpm E Min (Fam Free).mp3"
  },
  {
    "id": "melodic-trap/123-bpm-f-min-tilaver",
    "title": "123 Bpm F Min (Tilaver)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/123-bpm-f-min-tilaver.mp3",
    "source": "Melodic Trap/123 Bpm F Min (Tilaver).mp3"
  },
  {
    "id": "southside-trap/130-bpm-d-sharp-min-keman-synth-memphis",
    "title": "130 Bpm D# Min (Keman Synth Memphis)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/130-bpm-d-sharp-min-keman-synth-memphis.mp3",
    "source": "Southside Trap/130 Bpm D# Min (Keman Synth Memphis).mp3"
  },
  {
    "id": "90s/100-bpm-d-sharp-min-aress",
    "title": "100 Bpm D# Min (ARess)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/100-bpm-d-sharp-min-aress.mp3",
    "source": "90's/100 Bpm D# Min (ARess).mp3"
  },
  {
    "id": "southside-trap/130-bpm-e-min-gece-gunduz",
    "title": "130 Bpm E Min (Gece Gündüz)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/130-bpm-e-min-gece-gunduz.mp3",
    "source": "Southside Trap/130 Bpm E Min (Gece Gündüz).mp3"
  },
  {
    "id": "ambient/130-bpm-f-min-18ambient",
    "title": "130 Bpm F Min (18Ambient)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/130-bpm-f-min-18ambient.mp3",
    "source": "Ambient/130 Bpm F Min (18Ambient).mp3"
  },
  {
    "id": "melodic-trap/164-bpm-c-min-hats-off",
    "title": "164 Bpm C Min (Hats off)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/164-bpm-c-min-hats-off.mp3",
    "source": "Melodic Trap/164 Bpm C Min (Hats off).mp3"
  },
  {
    "id": "southside-trap/155-bpm-d-sharp-min-save-em",
    "title": "155 Bpm D# Min (Save Em)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/155-bpm-d-sharp-min-save-em.mp3",
    "source": "Southside Trap/155 Bpm D# Min (Save Em).mp3"
  },
  {
    "id": "melodic-trap/118-bpm-d-min-norw",
    "title": "118 Bpm D Min (Norw)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/118-bpm-d-min-norw.mp3",
    "source": "Melodic Trap/118 Bpm D Min (Norw).mp3"
  },
  {
    "id": "zateviss/130-bpm-g-maj-online",
    "title": "130 Bpm G Maj (Online)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/130-bpm-g-maj-online.mp3",
    "source": "Zateviss/130 Bpm G Maj (Online).mp3"
  },
  {
    "id": "90s/100-bpm-e-min-ganja",
    "title": "100 Bpm E Min (Ganja)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/100-bpm-e-min-ganja.mp3",
    "source": "90's/100 Bpm E Min (Ganja).mp3"
  },
  {
    "id": "melodic-trap/95-bpm-c-sharp-min-woo",
    "title": "95 Bpm C# Min (woo)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/95-bpm-c-sharp-min-woo.mp3",
    "source": "Melodic Trap/95 Bpm C# Min (woo).mp3"
  },
  {
    "id": "dance-music/130-bpm-c-sharp-min-ozi-x-pic-bocek",
    "title": "130 bpm C# Min (ozi x pic bocek)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/130-bpm-c-sharp-min-ozi-x-pic-bocek.mp3",
    "source": "Dance Music/130 bpm C# Min (ozi x pic bocek).mp3"
  },
  {
    "id": "melodic-trap/182-bpm-c-min-worst",
    "title": "182 Bpm C Min (Worst)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/182-bpm-c-min-worst.mp3",
    "source": "Melodic Trap/182 Bpm C Min (Worst).mp3"
  },
  {
    "id": "southside-trap/138-bpm-d-sharp-min-bouncy-pyrex-x-wheezy-type",
    "title": "138 Bpm D# Min (Bouncy Pyrex x Wheezy Type)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/138-bpm-d-sharp-min-bouncy-pyrex-x-wheezy-type.mp3",
    "source": "Southside Trap/138 Bpm D# Min (Bouncy Pyrex x Wheezy Type).mp3"
  },
  {
    "id": "melodic-trap/170-bpm-d-sharp-to-a-sharp-dont-kill-civillians",
    "title": "170 BPm D# to A# (Dont Kill Civillians)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/170-bpm-d-sharp-to-a-sharp-dont-kill-civillians.mp3",
    "source": "Melodic Trap/170 BPm D# to A# (Dont Kill Civillians).mp3"
  },
  {
    "id": "ambient/130-bpm-d-min-srnyr",
    "title": "130 Bpm D Min (Srnyr)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/130-bpm-d-min-srnyr.mp3",
    "source": "Ambient/130 Bpm D Min (Srnyr).mp3"
  },
  {
    "id": "melodic-trap/142-bpm-e-min-grah",
    "title": "142 Bpm E Min (GRAH)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/142-bpm-e-min-grah.mp3",
    "source": "Melodic Trap/142 Bpm E Min (GRAH).mp3"
  },
  {
    "id": "southside-trap/133-bpm-c-sharp-min-zate-x-casey-x-macshooter49",
    "title": "133 Bpm C# Min (zate x casey x macshooter49)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/133-bpm-c-sharp-min-zate-x-casey-x-macshooter49.mp3",
    "source": "Southside Trap/133 Bpm C# Min (zate x casey x macshooter49).mp3"
  },
  {
    "id": "dance-music/142-bpm-d-min-havana",
    "title": "142 Bpm D Min (Havana)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/142-bpm-d-min-havana.mp3",
    "source": "Dance Music/142 Bpm D Min (Havana).mp3"
  },
  {
    "id": "melodic-trap/155-bpm-c-min-vvs",
    "title": "155 Bpm C Min (vvs)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/155-bpm-c-min-vvs.mp3",
    "source": "Melodic Trap/155 Bpm C Min (vvs).mp3"
  },
  {
    "id": "dance-music/123-bpm-c-min-halo",
    "title": "123 Bpm C Min (Halo)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/123-bpm-c-min-halo.mp3",
    "source": "Dance Music/123 Bpm C Min (Halo).mp3"
  },
  {
    "id": "dance-music/102-bpm-d-sharp-min-one-call",
    "title": "102 Bpm D# Min (One Call)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/102-bpm-d-sharp-min-one-call.mp3",
    "source": "Dance Music/102 Bpm D# Min (One Call).mp3"
  },
  {
    "id": "melodic-trap/153-bpm-c-min-grays",
    "title": "153 Bpm C Min (Grays)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/153-bpm-c-min-grays.mp3",
    "source": "Melodic Trap/153 Bpm C Min (Grays).mp3"
  },
  {
    "id": "melodic-trap/185-bpm-e-maj-guitar-flint",
    "title": "185 Bpm E Maj (Guitar Flint)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/185-bpm-e-maj-guitar-flint.mp3",
    "source": "Melodic Trap/185 Bpm E Maj (Guitar Flint).mp3"
  },
  {
    "id": "southside-trap/158-bpm-d-sharp-min-route",
    "title": "158 Bpm D# Min (Route)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/158-bpm-d-sharp-min-route.mp3",
    "source": "Southside Trap/158 Bpm D# Min (Route).mp3"
  },
  {
    "id": "dance-music/110-bpm-d-min-vampir",
    "title": "110 Bpm D Min (Vampir)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/110-bpm-d-min-vampir.mp3",
    "source": "Dance Music/110 Bpm D Min (Vampir).mp3"
  },
  {
    "id": "southside-trap/135-bpm-d-min-bapbapbapbap",
    "title": "135 Bpm D Min (BapBapBapBap)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/135-bpm-d-min-bapbapbapbap.mp3",
    "source": "Southside Trap/135 Bpm D Min (BapBapBapBap).mp3"
  },
  {
    "id": "melodic-trap/176-bpm-a-min-digitals",
    "title": "176 Bpm A Min (Digitals)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/176-bpm-a-min-digitals.mp3",
    "source": "Melodic Trap/176 Bpm A Min (Digitals).mp3"
  },
  {
    "id": "90s/97-bpm-c-min-charge",
    "title": "97 Bpm C Min (Charge)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/97-bpm-c-min-charge.mp3",
    "source": "90's/97 Bpm C Min (Charge).mp3"
  },
  {
    "id": "southside-trap/150-bpm-d-sharp-min-kots",
    "title": "150 Bpm D# Min (KOTS)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/150-bpm-d-sharp-min-kots.mp3",
    "source": "Southside Trap/150 Bpm D# Min (KOTS).mp3"
  },
  {
    "id": "southside-trap/150-bpm-c-sharp-min-nardo-ft-matrix",
    "title": "150 Bpm C# Min (Nardo ft Matrix).",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/150-bpm-c-sharp-min-nardo-ft-matrix.mp3",
    "source": "Southside Trap/150 Bpm C# Min (Nardo ft Matrix)..mp3"
  },
  {
    "id": "90s/97-bpm-c-min-101",
    "title": "97 Bpm C Min (101)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/97-bpm-c-min-101.mp3",
    "source": "90's/97 Bpm C Min (101).mp3"
  },
  {
    "id": "melodic-trap/172-bpm-g-min-kaderin-oyunu",
    "title": "172 Bpm G Min (Kaderin Oyunu)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/172-bpm-g-min-kaderin-oyunu.mp3",
    "source": "Melodic Trap/172 Bpm G Min (Kaderin Oyunu).mp3"
  },
  {
    "id": "diger/118-bpm-c-min-dawn",
    "title": "118 Bpm C Min (Dawn)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/118-bpm-c-min-dawn.mp3",
    "source": "Diğer/118 Bpm C Min (Dawn).mp3"
  },
  {
    "id": "zateviss/97-bpm-g-maj-samandires",
    "title": "97 Bpm G Maj (Samandires...)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/97-bpm-g-maj-samandires.mp3",
    "source": "Zateviss/97 Bpm G Maj (Samandires...).mp3"
  },
  {
    "id": "ambient/154-bpm-e-min-even-if-idk",
    "title": "154 Bpm E Min (Even if idk)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/154-bpm-e-min-even-if-idk.wav",
    "source": "Ambient/154 Bpm E Min (Even if idk).wav"
  },
  {
    "id": "melodic-trap/130-bpm-d-min-beverly-slidin",
    "title": "130 Bpm D Min (Beverly Slidin)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/130-bpm-d-min-beverly-slidin.mp3",
    "source": "Melodic Trap/130 Bpm D Min (Beverly Slidin).mp3"
  },
  {
    "id": "melodic-trap/121-bpm-d-maj-tomorrow",
    "title": "121 Bpm D Maj (Tomorrow)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/121-bpm-d-maj-tomorrow.mp3",
    "source": "Melodic Trap/121 Bpm D Maj (Tomorrow).mp3"
  },
  {
    "id": "diger/130-bpm-c-min-utopia",
    "title": "130 Bpm C min (utopia)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/130-bpm-c-min-utopia.mp3",
    "source": "Diğer/130 Bpm C min (utopia).mp3"
  },
  {
    "id": "dance-music/130-bpm-g-sharp-min-sliced",
    "title": "130 Bpm G# Min (Sliced)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/130-bpm-g-sharp-min-sliced.mp3",
    "source": "Dance Music/130 Bpm G# Min (Sliced).mp3"
  },
  {
    "id": "southside-trap/190-bpm-b-min-haraketli-west-side-nardo-type",
    "title": "190 Bpm B Min (Haraketli West Side Nardo Type)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/190-bpm-b-min-haraketli-west-side-nardo-type.mp3",
    "source": "Southside Trap/190 Bpm B Min (Haraketli West Side Nardo Type).mp3"
  },
  {
    "id": "dance-music/105-bpm-f-sharp-min-hans-zimmer-x-uzi",
    "title": "105 Bpm F# Min (Hans Zimmer X Uzi)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/105-bpm-f-sharp-min-hans-zimmer-x-uzi.mp3",
    "source": "Dance Music/105 Bpm F# Min (Hans Zimmer X Uzi).mp3"
  },
  {
    "id": "ambient/87-bpm-d-min-trem-do-amor",
    "title": "87 Bpm D Min (Trem Do Amor)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/87-bpm-d-min-trem-do-amor.mp3",
    "source": "Ambient/87 Bpm D Min (Trem Do Amor).mp3"
  },
  {
    "id": "hoodtrap/155-bpm-e-min-mahalletuzagi",
    "title": "155 Bpm E Min (MahalleTuzağı)",
    "type": "Hoodtrap",
    "genre": "Hoodtrap",
    "key": "beats/hoodtrap/155-bpm-e-min-mahalletuzagi.mp3",
    "source": "Hoodtrap/155 Bpm E Min (MahalleTuzağı).mp3"
  },
  {
    "id": "ambient/140-bpm-d-min-decap",
    "title": "140 Bpm D Min (Decap)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/140-bpm-d-min-decap.mp3",
    "source": "Ambient/140 Bpm D Min (Decap).mp3"
  },
  {
    "id": "ambient/160-bpm-c-min-future-damar",
    "title": "160 Bpm C Min (Future Damar)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/160-bpm-c-min-future-damar.mp3",
    "source": "Ambient/160 Bpm C Min (Future Damar).mp3"
  },
  {
    "id": "hoodtrap/180-bpm-hdtrp",
    "title": "180 Bpm HDTRP",
    "type": "Hoodtrap",
    "genre": "Hoodtrap",
    "key": "beats/hoodtrap/180-bpm-hdtrp.mp3",
    "source": "Hoodtrap/180 Bpm HDTRP.mp3"
  },
  {
    "id": "zateviss/162-bpm-c-min-here-to-stay",
    "title": "162 Bpm C Min (Here To Stay)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/162-bpm-c-min-here-to-stay.mp3",
    "source": "Zateviss/162 Bpm C Min (Here To Stay).mp3"
  },
  {
    "id": "ambient/180-bpm-f-min-drivebymysoul",
    "title": "180 Bpm F Min (DriveByMySoul)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/180-bpm-f-min-drivebymysoul.mp3",
    "source": "Ambient/180 Bpm F Min (DriveByMySoul).mp3"
  },
  {
    "id": "southside-trap/116-bpm-a-min-fame-zv",
    "title": "116 Bpm A Min (Fame ZV)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/116-bpm-a-min-fame-zv.mp3",
    "source": "Southside Trap/116 Bpm A Min (Fame ZV).mp3"
  },
  {
    "id": "melodic-trap/138-bpm-e-min-too-much",
    "title": "138 Bpm E Min (Too Much)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/138-bpm-e-min-too-much.mp3",
    "source": "Melodic Trap/138 Bpm E Min (Too Much).mp3"
  },
  {
    "id": "diger/114-bpm-d-sharp-min-cocaine-model",
    "title": "114 Bpm D# Min (Cocaine Model)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/114-bpm-d-sharp-min-cocaine-model.mp3",
    "source": "Diğer/114 Bpm D# Min (Cocaine Model).mp3"
  },
  {
    "id": "melodic-trap/151-bpm-c-min-my-world-is-empty-without-you-stevie-wonder",
    "title": "151 Bpm C min (My world is empty without you Stevie Wonder)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/151-bpm-c-min-my-world-is-empty-without-you-stevie-wonder.mp3",
    "source": "Melodic Trap/151 Bpm C min (My world is empty without you Stevie Wonder).mp3"
  },
  {
    "id": "melodic-trap/110-bpm-d-sharp-min-ym",
    "title": "110 Bpm D# Min (YM)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/110-bpm-d-sharp-min-ym.mp3",
    "source": "Melodic Trap/110 Bpm D# Min (YM).mp3"
  },
  {
    "id": "90s/102-bpm-e-min-uyusturucu-adam",
    "title": "102 Bpm E Min (Uyusturucu Adam)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/102-bpm-e-min-uyusturucu-adam.mp3",
    "source": "90's/102 Bpm E Min (Uyusturucu Adam).mp3"
  },
  {
    "id": "90s/95-bpm-c-min-50-cent-emot",
    "title": "95 Bpm C Min (50 Cent Emot)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/95-bpm-c-min-50-cent-emot.mp3",
    "source": "90's/95 Bpm C Min (50 Cent Emot).mp3"
  },
  {
    "id": "melodic-trap/113-bpm-f-min-aggb",
    "title": "113 Bpm F Min (AGGB)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/113-bpm-f-min-aggb.mp3",
    "source": "Melodic Trap/113 Bpm F Min (AGGB).mp3"
  },
  {
    "id": "southside-trap/194-bpm-f-min-godfather-detroit",
    "title": "194 Bpm F Min (Godfather Detroit)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/194-bpm-f-min-godfather-detroit.mp3",
    "source": "Southside Trap/194 Bpm F Min (Godfather Detroit).mp3"
  },
  {
    "id": "southside-trap/155-bpm-f-min-guns",
    "title": "155 Bpm F Min (Guns)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/155-bpm-f-min-guns.mp3",
    "source": "Southside Trap/155 Bpm F Min (Guns).mp3"
  },
  {
    "id": "dance-music/105-bpm-c-sharp-min-alsancak",
    "title": "105 Bpm C# Min (Alsancak)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/105-bpm-c-sharp-min-alsancak.mp3",
    "source": "Dance Music/105 Bpm C# Min (Alsancak).mp3"
  },
  {
    "id": "zateviss/161-bpm-b-min-we-ll-nein",
    "title": "161 Bpm B Min (We ll Nein)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/161-bpm-b-min-we-ll-nein.mp3",
    "source": "Zateviss/161 Bpm B Min (We_ll Nein).mp3"
  },
  {
    "id": "zateviss/87-bpm-d-min-trem-do-amor",
    "title": "87 Bpm D Min (Trem Do Amor)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/87-bpm-d-min-trem-do-amor.mp3",
    "source": "Zateviss/87 Bpm D Min (Trem Do Amor).mp3"
  },
  {
    "id": "hoodtrap/192-bpm-c-min-esdeekid-x-fakemink-type",
    "title": "192 Bpm C Min (Esdeekid x Fakemink Type)",
    "type": "Hoodtrap",
    "genre": "Hoodtrap",
    "key": "beats/hoodtrap/192-bpm-c-min-esdeekid-x-fakemink-type.mp3",
    "source": "Hoodtrap/192 Bpm C Min (Esdeekid x Fakemink Type).mp3"
  },
  {
    "id": "dance-music/92-bpm-g-min-r-n-afrobeat",
    "title": "92 Bpm G Min (R&N Afrobeat)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/92-bpm-g-min-r-n-afrobeat.mp3",
    "source": "Dance Music/92 Bpm G Min (R&N Afrobeat).mp3"
  },
  {
    "id": "zateviss/175-bpm-c-jw",
    "title": "175 Bpm C (JW)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/175-bpm-c-jw.mp3",
    "source": "Zateviss/175 Bpm C (JW).mp3"
  },
  {
    "id": "southside-trap/158-bpm-f-sharp-min-bellismo",
    "title": "158 Bpm F# Min (Bellismo)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/158-bpm-f-sharp-min-bellismo.mp3",
    "source": "Southside Trap/158 Bpm F# Min (Bellismo).mp3"
  },
  {
    "id": "zateviss/145-bpm-d-sharp-maj-zatev1l",
    "title": "145 Bpm D# Maj (ZatEv1l)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/145-bpm-d-sharp-maj-zatev1l.mp3",
    "source": "Zateviss/145 Bpm D# Maj (ZatEv1l).mp3"
  },
  {
    "id": "southside-trap/180-bpm-d-min-wuah",
    "title": "180 Bpm D Min (WUAH)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/180-bpm-d-min-wuah.mp3",
    "source": "Southside Trap/180 Bpm D Min (WUAH).mp3"
  },
  {
    "id": "southside-trap/170-bpm-c-maj-zodiac",
    "title": "170 Bpm C Maj (Zodiac)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/170-bpm-c-maj-zodiac.mp3",
    "source": "Southside Trap/170 Bpm C Maj (Zodiac).mp3"
  },
  {
    "id": "zateviss/130-bpm-e-min-area-29",
    "title": "130 Bpm E Min (Area 29)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/130-bpm-e-min-area-29.mp3",
    "source": "Zateviss/130 Bpm E Min (Area 29).mp3"
  },
  {
    "id": "melodic-trap/126-bpm-a-sharp-min-leaves",
    "title": "126 Bpm A# Min (Leaves)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/126-bpm-a-sharp-min-leaves.mp3",
    "source": "Melodic Trap/126 Bpm A# Min (Leaves).mp3"
  },
  {
    "id": "southside-trap/151-bpm-c-min-alienware",
    "title": "151 Bpm C Min (AlienWare)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/151-bpm-c-min-alienware.mp3",
    "source": "Southside Trap/151 Bpm C Min (AlienWare).mp3"
  },
  {
    "id": "southside-trap/190-bpm-g-min-saldim",
    "title": "190 Bpm G Min (Saldım)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/190-bpm-g-min-saldim.mp3",
    "source": "Southside Trap/190 Bpm G Min (Saldım).mp3"
  },
  {
    "id": "melodic-trap/87-bpm-d-min-trem-do-amor",
    "title": "87 Bpm D Min (Trem Do Amor)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/87-bpm-d-min-trem-do-amor.mp3",
    "source": "Melodic Trap/87 Bpm D Min (Trem Do Amor).mp3"
  },
  {
    "id": "ambient/138-bpm-e-min-too-much",
    "title": "138 Bpm E Min (Too Much)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/138-bpm-e-min-too-much.mp3",
    "source": "Ambient/138 Bpm E Min (Too Much).mp3"
  },
  {
    "id": "zateviss/120-bpm-c-min-ldr",
    "title": "120 Bpm C Min (LDR)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/120-bpm-c-min-ldr.mp3",
    "source": "Zateviss/120 Bpm C Min (LDR).mp3"
  },
  {
    "id": "zateviss/111-bpm-c-min-ariana-fani",
    "title": "111 Bpm C Min (Ariana Fanı)",
    "type": "Zateviss",
    "genre": "Zateviss",
    "key": "beats/zateviss/111-bpm-c-min-ariana-fani.mp3",
    "source": "Zateviss/111 Bpm C Min (Ariana Fanı).mp3"
  },
  {
    "id": "southside-trap/120-bpm-c-min-quiche",
    "title": "120 Bpm C Min (Quiche)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/120-bpm-c-min-quiche.mp3",
    "source": "Southside Trap/120 Bpm C Min (Quiche).mp3"
  },
  {
    "id": "melodic-trap/150-bpm-f-maj-tryna-fuk",
    "title": "150 Bpm F Maj (Tryna fuk)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/150-bpm-f-maj-tryna-fuk.mp3",
    "source": "Melodic Trap/150 Bpm F Maj (Tryna fuk).mp3"
  },
  {
    "id": "southside-trap/120-bpm-e-min-vox-x-pyrex",
    "title": "120 Bpm E Min (Vox x Pyrex)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/120-bpm-e-min-vox-x-pyrex.mp3",
    "source": "Southside Trap/120 Bpm E Min (Vox x Pyrex).mp3"
  },
  {
    "id": "diger/137-bpm-c-sharp-min-i-ll-dance",
    "title": "137 Bpm C# Min (I ll Dance)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/137-bpm-c-sharp-min-i-ll-dance.mp3",
    "source": "Diğer/137 Bpm C# Min (I_ll Dance).mp3"
  },
  {
    "id": "melodic-trap/150-bpm-d-min-tell-me",
    "title": "150 Bpm D Min (Tell Me)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/150-bpm-d-min-tell-me.mp3",
    "source": "Melodic Trap/150 Bpm D Min (Tell Me).mp3"
  },
  {
    "id": "dance-music/130-bpm-c-min-bababa",
    "title": "130 Bpm C Min (BaBaBa)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/130-bpm-c-min-bababa.mp3",
    "source": "Dance Music/130 Bpm C Min (BaBaBa).mp3"
  },
  {
    "id": "southside-trap/170-bpm-d-min-lil-baby-next-uhh",
    "title": "170 Bpm D Min (Lil Baby next uhh)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/170-bpm-d-min-lil-baby-next-uhh.mp3",
    "source": "Southside Trap/170 Bpm D Min (Lil Baby next uhh).mp3"
  },
  {
    "id": "melodic-trap/110-bpm-d-sharp-min-mama-dont-worry",
    "title": "110 Bpm D# Min (Mama Dont Worry)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/110-bpm-d-sharp-min-mama-dont-worry.mp3",
    "source": "Melodic Trap/110 Bpm D# Min (Mama Dont Worry).mp3"
  },
  {
    "id": "melodic-trap/94-bpm-d-sharp-min-erciyes",
    "title": "94 Bpm D# Min (Erciyes)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/94-bpm-d-sharp-min-erciyes.mp3",
    "source": "Melodic Trap/94 Bpm D# Min (Erciyes).mp3"
  },
  {
    "id": "melodic-trap/160-bpm-f-min-dcore",
    "title": "160 Bpm F Min (DCore)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/160-bpm-f-min-dcore.mp3",
    "source": "Melodic Trap/160 Bpm F Min (DCore).mp3"
  },
  {
    "id": "dance-music/120-bpm-c-sharp-min-morad-x-club",
    "title": "120 Bpm C# Min (Morad x Club)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/120-bpm-c-sharp-min-morad-x-club.mp3",
    "source": "Dance Music/120 Bpm C# Min (Morad x Club).mp3"
  },
  {
    "id": "diger/90-bpm-c-sharp-min-5-on-it",
    "title": "90 Bpm C# min (5 on it)",
    "type": "Diğer",
    "genre": "Diğer",
    "key": "beats/diger/90-bpm-c-sharp-min-5-on-it.mp3",
    "source": "Diğer/90 Bpm C# min (5 on it).mp3"
  },
  {
    "id": "melodic-trap/170-bpm-f-min-go-crazy",
    "title": "170 Bpm F Min (Go Crazy)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/170-bpm-f-min-go-crazy.mp3",
    "source": "Melodic Trap/170 Bpm F Min (Go Crazy).mp3"
  },
  {
    "id": "ambient/108-bpm-c-min-lately-been",
    "title": "108 Bpm C Min (Lately been)",
    "type": "Ambient",
    "genre": "Ambient",
    "key": "beats/ambient/108-bpm-c-min-lately-been.mp3",
    "source": "Ambient/108 Bpm C Min (Lately been).mp3"
  },
  {
    "id": "melodic-trap/143-bpm-c-sharp-min-hold-the-strings",
    "title": "143 Bpm C# Min (Hold The Strings)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/143-bpm-c-sharp-min-hold-the-strings.mp3",
    "source": "Melodic Trap/143 Bpm C# Min (Hold The Strings).mp3"
  },
  {
    "id": "southside-trap/200-bpm-c-min-zehirli",
    "title": "200 Bpm C Min (Zehirli)",
    "type": "Southside Trap",
    "genre": "Southside Trap",
    "key": "beats/southside-trap/200-bpm-c-min-zehirli.mp3",
    "source": "Southside Trap/200 Bpm C Min (Zehirli).mp3"
  },
  {
    "id": "90s/95-bpm-d-sharp-min-timbo",
    "title": "95 Bpm D# Min (Timbo)",
    "type": "90's",
    "genre": "90's",
    "key": "beats/90s/95-bpm-d-sharp-min-timbo.mp3",
    "source": "90's/95 Bpm D# Min (Timbo) .mp3"
  },
  {
    "id": "melodic-trap/190-bpm-g-min-saldim",
    "title": "190 Bpm G Min (Saldım)",
    "type": "Melodic Trap",
    "genre": "Melodic Trap",
    "key": "beats/melodic-trap/190-bpm-g-min-saldim.mp3",
    "source": "Melodic Trap/190 Bpm G Min (Saldım).mp3"
  },
  {
    "id": "dance-music/128-bpm-g-min-a-aa-a-au",
    "title": "128 Bpm G Min (A Aa A Au)",
    "type": "Dance Music",
    "genre": "Dance Music",
    "key": "beats/dance-music/128-bpm-g-min-a-aa-a-au.mp3",
    "source": "Dance Music/128 Bpm G Min (A Aa A Au).mp3"
  }
];

export const beatTypes = [
  "All",
  "90's",
  "Ambient",
  "Dance Music",
  "Diğer",
  "Hoodtrap",
  "Melodic Trap",
  "Pluggnb & Rage",
  "Southside Trap",
  "Zateviss"
];
